import { render, staticRenderFns } from "./ProjectAddVersionModal.vue?vue&type=template&id=2c0abcf0&scoped=true&"
import script from "./ProjectAddVersionModal.vue?vue&type=script&lang=js&"
export * from "./ProjectAddVersionModal.vue?vue&type=script&lang=js&"
import style0 from "./ProjectAddVersionModal.vue?vue&type=style&index=0&id=2c0abcf0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c0abcf0",
  null
  
)

export default component.exports